import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import WizardModel from "components/Wizard/WizardModel";

class WizardModelContainer extends React.PureComponent {
  render() {
    return <WizardModel {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(WizardModelContainer);
